import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { GipExportConfigInfo } from '@app/modules/audit/modules/global-audit/screens/gip/gip-report/export/info/GipExportConfigInfo';
import { auditReports } from '@mi-front/api-clients';
import { Box, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  aodGipExportMessages,
  packageStorageStrategyMessageByValue,
} from '../aod-gip-export-messages';

/**
 * Wraps GipExportConfigInfo and appends AOD-specific export option (packageStorageStrategy) at the bottom.
 */
export function AodGipExportConfigInfo({
  config,
}: {
  config: auditReports.GipAodRuleEvidenceExportOptionsDto;
}) {
  const strategy = config.packageStorageStrategy ?? 'PER_RUN';

  return (
    <Stack>
      <GipExportConfigInfo config={config} />
      <Box sx={{ mt: 3 }}>
        <InfoM label={<FormattedMessage {...aodGipExportMessages.packageStorageStrategyLabel} />}>
          <FormattedMessage {...packageStorageStrategyMessageByValue[strategy]} />
        </InfoM>
      </Box>
    </Stack>
  );
}
